<template>
  <div class="email-register">
    <div class="side-image">
      <v-img
        :src="backgroundImage"
        class="img-register"
      />
    </div>
    <div class="register-content">
      <div class="register-card">
        <h1>{{ $t('emailRegister.title') }}</h1>
        <p>{{ $t('emailRegister.subtitle') }}</p>
        <v-text-field
          v-model="email"
          :label="$t('emailRegister.emailLabel')"
          type="email"
          height="50"
          background-color="field_register"
          class="input-email"
        />
        <v-btn
          color="primary"
          :disabled="!email"
          @click="sendEmail"
        >
          {{ $t('emailRegister.advance') }}
        </v-btn>
      </div>
    </div>
  </div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
import imgBottles from '@/assets/register/garrafas.png';

export default {
  name: 'EmailRegister',
  data() {
    return {
      email: '',
    };
  },
  computed: {
    ...mapGetters(['getEmailSent']),
    backgroundImage() {
      return imgBottles;
    },
  },
  methods: {
    ...mapActions(['sendEmailToken']),

    sendEmail() {
      this.sendEmailToken({ email: this.email });
    },
  },
  watch: {
    getEmailSent(value) {
      if (value) {
        this.$router.push({ name: 'validate-email' });
      }
    },
  },
};
</script>
<style lang="scss" scoped>
.email-register {
  display: flex;
  flex-direction: row;
  height: 100vh;

  .side-image {
    width: 40%;
    background-color: $step_register_campany;
    .img-register {
      height: 100%;
      width: 100%;
      object-fit: cover;
      filter: none;
    }
  }

  .register-content {
    width: 60%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: $register_background;
  }

  .register-card {
    background: $card_background;
    border-radius: 16px;
    box-shadow: 0 2px 8px $card_shadow;
    padding: 40px 32px;
    min-width: 340px;
    max-width: 400px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 24px;
    h1 {
      font-size: 2rem;
      font-weight: bold;
      margin-bottom: 8px;
      text-align: center;
    }
    p {
      color: $subtitle_gray;
      margin-bottom: 16px;
      text-align: center;
    }
    .input-email {
      width: 100%;
      border-radius: 8px;
    }
  }
}
@media (max-width: 1100px) {
  .email-register {
    display: flex;
    justify-content: center;
    .side-image {
      display: none;
    }
    .register-content {
      width: 100%;
    }
  }
}
</style>
